import type { CMSAssetItem } from '../../types';
import { useState } from 'react';
import { Body, Button, Col, Row, Stack, SubHeading } from '@workramp/ui';
import { I18n } from '~/common/explicit-exports';
import { TableEmptyStateContainer } from '../CMSAssetLocationsTable/CMSAssetLocationsTable.styles';
import { CMSLibrariesDrawer } from '../CMSLibrariesDrawer';

export interface CMSEmptyTableProps {
  asset: CMSAssetItem;
  subheading: string;
  body: string;
}

const { t } = I18n;

export const CMSEmptyTable = ({ asset, subheading, body }: CMSEmptyTableProps) => {
  const [isLibraryDrawerOpen, setIsLibraryDrawerOpen] = useState(false);

  return (
    <>
      <TableEmptyStateContainer>
        <Stack size={6}>
          <Row>
            <Col>
              <Stack size={2}>
                <SubHeading level="md">{subheading}</SubHeading>
                <Body level="md">{body}</Body>
              </Stack>
            </Col>
          </Row>
          <Row>
            <Col>
              <Button
                aria-label={t('js.admin.cms.actions.add_to_library')}
                variant="outline"
                color="secondary"
                size="lg"
                onPress={() => {
                  setIsLibraryDrawerOpen(true);
                }}
              >
                {t('js.admin.cms.actions.add_to_library')}
              </Button>
            </Col>
          </Row>
        </Stack>
      </TableEmptyStateContainer>
      <CMSLibrariesDrawer
        asset={asset}
        isOpen={isLibraryDrawerOpen}
        onClose={() => {
          setIsLibraryDrawerOpen(false);
        }}
      />
    </>
  );
};
